"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertNoUnrecognizedKeys = assertNoUnrecognizedKeys;
const http_assert_1 = __importDefault(require("http-assert"));
/** The keys are echoed into the reply and the logs, so a large body must not flood either. */
const MAX_NAMED_KEYS = 5;
const MAX_KEY_LENGTH = 50;
const formatKey = (key) => key.length > MAX_KEY_LENGTH
    ? `\`${key.slice(0, MAX_KEY_LENGTH)}…\``
    : `\`${key}\``;
/**
 * Throws a 400 naming the keys of `value` that are not in `allowedKeys`: at
 * most the first five, each trimmed to 50 characters. Shared by the
 * axe-devtools proxy and axe-result so both report an unrecognized key with
 * the same message.
 */
function assertNoUnrecognizedKeys(value, allowedKeys, field) {
    const unrecognized = Object.keys(value).filter(key => !allowedKeys.includes(key));
    const remaining = unrecognized.length - MAX_NAMED_KEYS;
    (0, http_assert_1.default)(unrecognized.length === 0, 400, `Unrecognized key(s) in \`${field}\`: ${unrecognized
        .slice(0, MAX_NAMED_KEYS)
        .map(formatKey)
        .join(', ')}${remaining > 0 ? ` and ${remaining} more` : ''}`);
}
//# sourceMappingURL=assertNoUnrecognizedKeys.js.map